module.exports = __webpack_public_path__ + "h5/img/value.1a9c0425.jpg";